module.exports = __webpack_public_path__ + "img/microphone.3e6517be.svg";